import React, {useContext, useEffect} from "react";
import {useLocation} from "react-router-dom";
import LoaderCircle from "../../loader/LoaderCircle";
/*
import FormSheet from "../sheet/FormSheet";
import FrontSheet from "../sheet/FrontSheet";
 */
import FormPwd from "../../form/account/FormPwd";
import BackofficeContext from "../../../context/BackofficeContext";

const Popup = () => {
    const {objectPopup, setStatePopup, getDatasPopup, setGetDatasPopup, statePopup, popupLoadingText} = useContext(BackofficeContext);
    const location = useLocation();

    const buildContainer = () => {
        switch (statePopup) {
            case "loading":
                return <div className={"containerLoading"}>
                    <LoaderCircle display="loader inPopup" hide="" strokeWidth="10" stroke="#00000070"/>
                    {popupLoadingText !== null && <p className={"loadingText"}>{popupLoadingText}</p>}
                </div>

            case "new":
            case "request":
            case "sheet":
                return buildContent()

            default:
                break
        }
    }
    const buildContent = () => {
        switch (objectPopup) {
            case "client":
                switch (statePopup) {
                    /*
                    case "new":
                    return <FormSheet
                        objectType={ objectPopup }
                        objectSubType={ statePopup }
                        datas={ getDatasPopup }
                        parentDatas={ null }
                        title={ "Nouveau client" }
                        previousLink={ "/clients" }
                        successLink={ "/clients/:id/informations" } />
                    case "request":
                    return <FormSheet
                        objectType={ objectPopup }
                        objectSubType={ statePopup }
                        datas={ getDatasPopup }
                        parentDatas={ null }
                        title={ "Demande de création" }
                        previousLink={ "/clients" }
                        successLink={ "/clients" } />
                    case "sheet":
                        let previousLink = "/clients";

                        if (location.pathname.includes("/dashboard")) previousLink = "/dashboard";

                        return <FrontSheet
                            objectType={objectPopup}
                            datas={getDatasPopup}
                            previousLink={previousLink}/>
                    */
                    default:
                        break;
                }

                break
            case "userPassword":
                switch (statePopup) {
                    case "new":
                        return <FormPwd
                            object={getDatasPopup.user}
                            title={"Définir votre mot de passe"}/>
                    default:
                        break
                }

                break
            default:
                break;
        }
    }

    useEffect(() => {
        if (statePopup === null || statePopup === "hidden") {
            setGetDatasPopup(null);

            if (statePopup === "hidden") setStatePopup(null);
        }
    }, [statePopup]);

    return (
        <div className={"overlayPopup" + ((statePopup !== null && statePopup !== "hidden") ? " appear" : "")}>
            <div className={"wrapPopup"}>
                <div className={"popup" + (objectPopup !== null ? " " + objectPopup : "") + ((statePopup !== null && statePopup !== "hidden") ? " " + statePopup : "")}>
                    {buildContainer()}
                </div>
            </div>
        </div>
    );
}

export default Popup;